/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

export const HeadingText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '28px',
}));

export const HeadingBox = styled(Box)(({theme}) => ({
  margin: theme.spacing(8, 0),
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',

  '.MuiSvgIcon-root': {
    color: theme.palette.figma_emerald?.main,
  },
}));

export const TariffCard = styled(Box)(({theme}) => ({
  borderRadius: '32px',
  background: theme.palette.figma_surface?.main,
  padding: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  maxWidth: 'min-content',
  minWidth: '500px',
}));

export const TariffBorderBlock = styled(Box)(({theme}) => ({
  borderRadius: '8px',
  border: `1px solid ${theme.palette.figma_gray_dark_4?.main}`,
  overflow: 'hidden',
  display: 'flex',
  gap: '1px',
  background: theme.palette.figma_gray_dark_4?.main,
}));

export const TariffBlock = styled(Box)(({theme}) => ({
  minWidth: 'max-content',
  width: '100%',
  background: theme.palette.figma_surface?.main,
  padding: theme.spacing(4),
}));

export const BlockWrap = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
}));

export const DescriptionWrap = styled(Box)(({theme}) => ({
  height: '116px',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  justifyContent: 'flex-end',
}));

export const RegularText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const TariffNameText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '28px',
}));

export const ButtonsBox = styled(Box)(() => ({
  display: 'flex',
  gap: '1px',
  borderRadius: '8px',
  overflow: 'hidden',
}));

export const ButtonSupport = styled(Button)(({theme}) => ({
  gap: theme.spacing(2),
  borderRadius: 0,
  height: '32px',
  width: '225px',
  flexShrink: 0,
  background: theme.palette.figma_gray_dark_4?.main,

  '&:hover': {
    background: theme.palette.figma_gray_middle_dark?.dark,
  },

  '&.Mui-disabled': {
    background: '#1d1e20',
    color: theme.palette.figma_disabled?.main,

    p: {
      color: theme.palette.figma_disabled?.main,
    },
  },
}));

export const ButtonBuy = styled(Button)(({theme}) => ({
  gap: theme.spacing(2),
  borderRadius: 0,
  height: '32px',
  width: '100%',
  background: theme.palette.figma_primary?.dark,

  '&:hover': {
    background: theme.palette.figma_primary?.main,
  },

  '&.Mui-disabled': {
    background: '#22384a',
    color: theme.palette.figma_disabled?.main,

    p: {
      color: theme.palette.figma_disabled?.main,
    },
  },
}));

export const ButtonText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const ModalContent = styled(Box)(() => ({
  width: '305px',
}));
